<ul class="nav nav-pills nav-justified">
  <li class="nav-item tabs" [routerLink]="['pipeline']">
    <a [routerLink]="['pipeline']" [routerLinkActive]="['active']">Pipeline</a>
  </li>
  <li class="nav-item tabs" [routerLink]="['services']">
    <a [routerLink]="['services']" [routerLinkActive]="['active']">Services</a>
  </li>
</ul>